// extracted by mini-css-extract-plugin
export default {"radioOptionsCont":"DescriptionSettingsModule_radioOptionsCont__X6Ciz"};